import React from 'react'
import PageLayout from '../components/templates/page-layout/page-layout'
import useMediaQuery from '../shared/utils/useMediaQuery'
import ContentLearn from '../components/organisms/contentLearn/ContentLearn'
import UseValidateView from '../utils/useValidateView'

const Aprende = () => {
  const isMobile = useMediaQuery()

  const [isSession] = UseValidateView()


  return (
    <>
        <PageLayout mobile={isMobile} isLogged={isSession}>
          <ContentLearn />
        </PageLayout>
    </>
  )
}

export default Aprende
